'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

function NavbarCloseEvent() {

    const pathname = usePathname()
    const searchParams = useSearchParams()

    const navbarToggle = document.getElementById('navbar-toggle')
    const navbarCollapse = document.getElementById('categories')

    useEffect(() => {
        if (!navbarCollapse?.classList.contains('hidden')) {
            navbarToggle?.click()
        }
    }, [ pathname, searchParams ]);

    return null

}

export default NavbarCloseEvent